<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M9.24986 5.875H8.45956C6.92586 5.875 6.3807 7.90469 7.70801 8.67317L12.2917 11.3269C13.619 12.0953 13.0739 14.125 11.5401 14.125H7.74986" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M14.125 4V7.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M16.005 5.87012L12.255 5.87012" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4 15.25V13C4 12.5858 4.33579 12.25 4.75 12.25H7C7.41421 12.25 7.75 12.5858 7.75 13V15.25C7.75 15.6642 7.41421 16 7 16H4.75C4.33579 16 4 15.6642 4 15.25Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'ConnectDataSourceIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>